export default "__VITE_ASSET__DaAk3319__"